import CreateCard from '@helpers/CreateCard';
import { useEffect, useRef } from 'react';
import { UseHitsProps, useInfiniteHits } from 'react-instantsearch';

export default function InfiniteHits(props: UseHitsProps) {
  const { hits, sendEvent, showMore, isLastPage } = useInfiniteHits(props);
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (sentinelRef.current !== null) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLastPage) {
            showMore();
          }
        });
      });

      observer.observe(sentinelRef.current);

      return () => {
        observer.disconnect();
      };
    }
  }, [isLastPage, showMore]);

  return (
    <div className="ais-InfiniteHits flex flex-col justify-items-center">
      <ul className="ais-InfiniteHits-list not-prose grid grid-cols-1 gap-y-4 py-8 md:grid-cols-2 md:gap-x-2 lg:grid-cols-3">
        {hits.map((item) => {
          return (
            <li
              key={`search-${item.objectID}`}
              onClick={() =>
                sendEvent('conversion', item, 'Search Result Clicked')
              }>
              {CreateCard({ item: item })}
            </li>
          );
        })}
        <li ref={sentinelRef} aria-hidden="true" />
      </ul>
    </div>
  );
}
